import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class AccountTrader {
  @JsonProperty()
  id: number = -1;
  @JsonProperty()
  traderCode: string | undefined;
  @JsonProperty()
  exchangeCode: string | undefined;
  @JsonProperty()
  contractListInclude:boolean;
  @JsonProperty()
  contractList: string | undefined;
  @JsonProperty()
  accountCode: string | undefined;
  @JsonProperty()
  customerName: string | undefined;
  @JsonProperty()
  owner: string | undefined;
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
